import { HTTP } from "@/axios.js"
import store from '@/store.js'
export default {
    manageWorkScheduleList: () => {
        return HTTP.get('/work_schedule/menage', {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },    
    employeeHolidayCreate: (data) => {
        return HTTP.post('/work_time/employeeHolidayCreate',data,{
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    examineLeave: (id) => {
        return HTTP.get('/work_time/examineLeave/'+id,{
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    examineLeaveUpdate: (id,data) => {
        return HTTP.post('/work_time/examineLeaveUpdate/'+id,data,{
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
}